export default function PrivacyPolicyPage() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', fontFamily: 'Inter, sans-serif', color: '#1c2b22' }}>
      <h1 style={{ fontSize: 28, marginBottom: 8 }}>Нууцлалын бодлого</h1>
      <p style={{ color: '#666', marginBottom: 32 }}>Сүүлд шинэчлэгдсэн: 2025 оны 6-р сарын 27</p>

      <p>"Сайн Хөрш" аппликейшн нь Сүхбаатар Инвест ХХК-аас хөгжүүлж буй сууц өмчлөгчдийн холбоо (СӨХ)-ны удирдлагын систем юм. Бид таны хувийн мэдээллийг хамгаалахыг чухалчилдаг.</p>

      <h2 style={{ fontSize: 20, marginTop: 32 }}>1. Цуглуулдаг мэдээлэл</h2>
      <ul>
        <li><strong>Бүртгэлийн мэдээлэл:</strong> Нэр, имэйл хаяг, утасны дугаар, байрны дугаар</li>
        <li><strong>Төлбөрийн мэдээлэл:</strong> Нэхэмжлэх, төлбөрийн түүх (банкны карт, дансны мэдээлэл хадгалдаггүй)</li>
        <li><strong>Хандалтын мэдээлэл:</strong> Нэвтрэх картын бүртгэл, нэвтрэлтийн лог</li>
        <li><strong>Засвар үйлчилгээний хүсэлт:</strong> Өргөдөл, гомдлын агуулга, зураг</li>
      </ul>

      <h2 style={{ fontSize: 20, marginTop: 32 }}>2. Мэдээллийг хэрхэн ашигладаг</h2>
      <ul>
        <li>СӨХ-ны үйл ажиллагааг удирдах, нэхэмжлэх илгээх</li>
        <li>Засвар үйлчилгээний хүсэлтийг шийдвэрлэх</li>
        <li>Нэвтрэх хяналтын системийг ажиллуулах</li>
        <li>Зарлал, мэдэгдэл илгээх</li>
      </ul>

      <h2 style={{ fontSize: 20, marginTop: 32 }}>3. Мэдээллийн хамгаалалт</h2>
      <p>Таны мэдээлэл SSL/TLS шифрлэлтээр хамгаалагдсан серверт хадгалагдана. Зөвхөн эрх бүхий ажилтнууд хандах боломжтой.</p>

      <h2 style={{ fontSize: 20, marginTop: 32 }}>4. Гуравдагч талд дамжуулах</h2>
      <p>Бид таны хувийн мэдээллийг гуравдагч талд зарж борлуулдаггүй. Зөвхөн хуулиар шаардсан тохиолдолд эрх бүхий байгууллагад гаргаж өгнө.</p>

      <h2 style={{ fontSize: 20, marginTop: 32 }}>5. Таны эрхүүд</h2>
      <ul>
        <li>Өөрийн мэдээлэлтэй танилцах, залруулах хүсэлт гаргах</li>
        <li>Бүртгэлээ устгуулах хүсэлт гаргах</li>
        <li>Мэдэгдэл хүлээн авахаас татгалзах</li>
      </ul>

      <h2 style={{ fontSize: 20, marginTop: 32 }}>6. Холбоо барих</h2>
      <p>Нууцлалын бодлоготой холбоотой асуулт байвал доорх хаягаар холбогдоно уу:</p>
      <p>
        Имэйл: <a href="mailto:nationalmobile976@gmail.com" style={{ color: '#2f7d52' }}>nationalmobile976@gmail.com</a><br />
        Вэб: <a href="https://sainhursh.mn" style={{ color: '#2f7d52' }}>sainhursh.mn</a>
      </p>

      <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid #eee', color: '#999', fontSize: 13 }}>
        © 2025 Сайн Хөрш. Бүх эрх хуулиар хамгаалагдсан.
      </div>
    </div>
  );
}
